import { requestFromServer } from "./api-client";

const LoadTypes = {
	list: async (id) => {
		return requestFromServer(`v1/Load_Types/list`);
	},
};

export default LoadTypes;
